<template>
  <el-dialog title="选择模板" :visible="true" width="1200px" center @close="dialogClose">
    <div class="itemList">
      <div class="item">
        <div class="wrapper-kaika">
          <!-- 品牌定制 -->
          <div @click="handleOpen()" class="wrapper-kaika-img pointer">
            <div class="borderkaika" style="width: 100%;height: 100%;top:0;left:0;background:rgba(38, 112, 251, 0.05)"></div>
            <div style="margin-top: 155px;">
              <img src="../../assets/images/integralCenter/dingzhi.png" alt="" />
              <div>品牌定制</div>
            </div>
          </div>
          <!-- 礼包模板 -->
          <!-- 235 419 -->
          <div class="wrapper-kaika-img wrapperBg" v-for="item in giftArr" :key="item.id">
            <div class="borderkaika"></div>
            <div class="wrapper-kaika-tanchuang">
              <img style="width: 188px; height: 135px;margin-bottom: 10px" :src="item.picOne" alt="" />
              <img style="width: 188px; height: 135px" :src="item.picSec" alt="" />
            </div>
            <div class="wrapper-kaika-bottom">模板ID：{{ item.id }}</div>
            <div style="position: absolute;bottom: -30px;width: 100%;font-size: 12px;">
              <el-checkbox v-model="item.checked"></el-checkbox>
            </div>
            <div v-if="item.templateType == 2" style="position: absolute;bottom: 42px;width: 100%;color: red;font-size: 12px;">
              <span style="left: 10px;position: absolute;font-weight: 500;">限免</span>
              <span style="right: 10px;position: absolute;font-weight: 500;">倒计时：{{ item.days }}</span>
            </div>
            <div class="mask">
              <div class="img">
                <div class="imgBg">
                  <div class="qrCodeIMG" id="queryIdIMG" ref="queryIdIMG"></div>
                  <!-- <img :src="activityData.telCode" alt="" /> -->
                </div>
                <span class="tpl">手机扫码预览模板</span>
                <!-- <div id="qrcode" ref="qrcode" class="qrcodeIcon"></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" style="display: flex;justify-content: end;margin-right: 60px;">
      <el-button @click="dialogClose()">取消</el-button>
      <el-button type="primary" @click="nextStepKai()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
// import { getGameTemplate } from "@/api/paradiseAndTaskCommonController.js";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";

export default {
  props: {
    gameTemplateList: {
      type: Array,
      default: [],
    },
    giftList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      giftArr: [],
      idUrl: "",
    };
  },
  async created() {
    this.getPolite();
  },
  methods: {
    async getPolite() {
      // 开卡礼包版本
      if (this.gameTemplateList.length !== 0) {
        this.giftArr = this.giftList.map((item) => {
          let obj = { ...item };
          obj.checked = false;
          this.gameTemplateList.forEach((val) => {
            if (val == item.id) {
              obj.checked = true;
            }
          });
          return obj;
        });
      } else {
        this.giftArr = this.giftList.map((item) => {
          return {
            ...item,
            checked: false,
          };
        });
      }
      // const res = await prefixurl();
      // this.idUrl = res.data.activityUrl + "/" + "clientPreview" + "?venderId=" + res.data.venderId;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    nextStepKai() {
      const arr = this.giftArr.filter((i) => i.checked);
      if (arr.length == 0) {
        return this.$message.warning("请勾选游戏模板哦~");
      }
      this.$emit("handleTemplate", arr);
    },
    dialogClose() {
      this.$emit("handleTemplate");
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = `https://m.duanqu.com/?_ariver_appid=3000000075963142&_mp_code=tb&transition=present&query=sellerId%3D2333763673%26activityId%3D38%26activityType%3D24%26target%3DseekDistinct`;
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 117, // 设置宽度，单位像素
          height: 117, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url,
          // correctLevel: QRCode.CorrectLevel.L,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navTab {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  span {
    height: 50px;
    line-height: 50px;
    position: relative;
    padding: 0 11px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #2062e7;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80%;
      height: 2px;
      background-color: #2062e7;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.itemList {
  display: flex;
  .item {
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    position: relative;
    color: #666;
    text-align: center;
    padding: 6px;
    &:hover {
      .border::before,
      .border::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .border {
      position: absolute;
      left: 0;
      top: 0;
      // width: 100%;
      height: 100%;
      width: 253px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #2062e7;
        border-bottom: 1px solid #2062e7;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #2062e7;
        border-left: 1px solid #2062e7;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    .wrapper-kaika {
      width: 100%;
      height: 100%;
      display: grid;
      // align-items: center;
      // justify-content: center;

      &-img {
        background-color: #fafafa;
        border: 1px solid #dcdfe6;
        border-radius: 8px;
        height: 350px;
        margin-right: 20px;
        position: relative;
        &:hover {
          .borderkaika::before,
          .borderkaika::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .borderkaika {
          position: absolute;
          left: -6px;
          top: -6px;
          width: 218px;
          height: 360px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2062e7;
            border-bottom: 1px solid #2062e7;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2062e7;
            border-left: 1px solid #2062e7;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        div {
          font-size: 18px;
          font-weight: bold;
          // line-height: 25px;
          color: #333333;
        }
        img {
          width: 32px;
          height: 32px;
        }

        .queryIdIMG {
          display: none;
        }
        &:hover {
          .queryIdIMG {
            display: block;
          }
          .mask {
            opacity: 1;
          }
        }
        .mask {
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
          opacity: 0;
          transition: all 0.2s;
          height: 92.5%;
          .img {
            max-width: 130px;
            margin: 0 auto 30px;
            .imgBg {
              box-sizing: border-box;
              height: 129px;
              width: 129px;
              padding: 6px;
              border-radius: 6px;
              background-color: #fff;
            }
            .tpl {
              display: inline-block;
              font-size: 14px;
              color: #fff;
              margin-top: 10px;
              // opacity: 0.7;
            }
          }
          .mask-gift {
            position: absolute;
            bottom: 3px;
            width: 100%;
            div {
              text-align: center;
              color: #ffffff !important;
              font-size: 12px !important;
              opacity: 0.7;
              font-weight: 500 !important;
              line-height: 19px;
            }
          }
        }
      }
      &-tanchuang {
        position: absolute;
        // top: 50%;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      &-bottom {
        width: 102%;
        height: 30px;
        background: #ffffff;
        border: 1px solid #e7e7e7;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        color: #666 !important;
        position: absolute;
        bottom: -4px;
        left: -2px;
        line-height: 30px;
        font-size: 14px !important;
        text-align: left;
        padding-left: 10px;
        font-weight: 500 !important;
      }
      .lijijq {
        &::after {
          content: "立即领取";
          display: block;
          position: absolute;
          bottom: 9px;
          left: 51%;
          transform: translateX(-50%);
          font-size: 14px;
          font-family: system-ui;
          font-weight: bold;
          color: #ed6e09;
          text-shadow: 0 0 black;
        }
      }
    }
    .wrapper {
      position: relative;
      height: 350px;
      border-radius: 6px;
      overflow: hidden;
      display: grid;
      .queryId {
        display: none;
      }
      &:hover {
        .queryId {
          display: block;
        }
        .mask {
          opacity: 1;
        }
      }
      .mask {
        width: 240px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        opacity: 0;
        transition: all 0.2s;
        .img {
          max-width: 130px;
          margin: 0 auto 30px;
          .imgBg {
            box-sizing: border-box;
            height: 129px;
            width: 129px;
            padding: 6px;
            border-radius: 6px;
            background-color: #fff;
          }
          .tpl {
            display: inline-block;
            margin-top: 10px;
            color: #fff;
            // opacity: 0.7;
          }
        }
      }
    }
  }
}
.wrapper-kaika-img {
  width: 210px;
  height: 374px;
  margin-bottom: 40px;
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>
